// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteOutlinedSvg from "@fishx/icons-svg/es/asn/DeleteOutlined";
import FishxIcon from '../components/FishxIcon';

var DeleteOutlined = function DeleteOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteOutlinedSvg
  }));
};

DeleteOutlined.displayName = 'DeleteOutlined';
export default React.forwardRef(DeleteOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DeleteOutlined.js
// module id = 2389
// module chunks = 0